import "./payment.css";
import { formatWithCommas } from "../../utils/helper";
import CurrencyTooltip from "../../components/currencytooltip/CurrencyTooltip";
import UtilHelper from "../../utils/UtilHelper";
import { useCurrencySymbol } from "../../hooks/useCurrencySymbol";
interface PaymentOutstandingAmountProps {
  amount: string
  label: string
}

export default function PaymentOutstandingAmount({ amount, label}: PaymentOutstandingAmountProps) {
  const currencySymbol = useCurrencySymbol();
  return (
    <div className="payment-Outstanding-container">
      <div className="payment-Outstanding-row">
        <span className="payment-Outstanding-label">{label}</span>
         <div style={{ flex: 1}}></div>
         <CurrencyTooltip
          content={formatWithCommas(amount)}
          formatted={UtilHelper.CurrencyFormat(amount, true)}
         >
        <span className="payment-amount">{UtilHelper.formatCurrency(amount, false, currencySymbol)}</span>
        </CurrencyTooltip>
      </div>
    </div>
  )
}